<template>
  <div class="info-tabs lg:pl-10 pt-5 lg:pt-0">
    <div class="flex bg-smoke-100 p-5 rounded-lg">
      <button
        class="font-semibold"
        :class="`opacity-${activeTab === 'products' ? '100' : '50'}`"
        @click="activeTab = 'products'"
      >
        Products
      </button>
      <button
        class="ml-8 font-semibold"
        :class="`opacity-${activeTab === 'about' ? '100' : '50'}`"
        @click="activeTab = 'about'"
      >
        About
      </button>
    </div>
    <div class="py-10">
      <ProductsDetailTab
        v-if="activeTab === 'products'"
        :products="supplier.products"
        :main-products="supplier.mainProducts"
      />
      <AboutTab
        v-if="activeTab === 'about'"
        :supplier="supplier"
      />
    </div>
  </div>
</template>
<script>
import ProductsDetailTab from './ProductsDetailTab'
import AboutTab from './AboutTab'

export default {
  name: 'SupplierInfoTabs',
  components: {
    ProductsDetailTab,
    AboutTab
  },
  props: {
    supplier: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTab: 'products'
    }
  }
}
</script>
<style lang="scss" scoped>
  .info-tabs {
    @screen lg {
      width: calc(100% - 20rem);
      @apply inline-block align-top;
    }
  }
</style>